/**
 * @module Reducers.spaceTemplates
 *
 */
import { RequestError } from "typedefs";
import { SpaceTemplatesModel } from "app/models";
import { SpaceTemplateAction } from "app/actions/spaceTemplate";

export type SpaceTemplateState = {
  data: SpaceTemplatesModel[] | null;
  selectedTemplate: SpaceTemplatesModel | null;
  error: RequestError | null;
  pending: boolean;
};

const initialState: SpaceTemplateState = {
  data: null,
  selectedTemplate: null,
  error: null,
  pending: true,
};

export default function SpaceTemplateReducer(
  state = initialState,
  action: SpaceTemplateAction,
): SpaceTemplateState {
  switch (action.type) {
    case "@spaceTemplate.fetch.success":
      return { ...state, data: action.payload, pending: false };
    case "@spaceTemplate.fetch.selectedTemplate":
      return { ...state, selectedTemplate: action.payload, pending: false };
    case "@spaceTemplate.fetch.pending":
      return { ...state, error: null, pending: true };
    case "@spaceTemplate.fetch.error":
      return { ...state, error: action.payload, pending: false };
    case "@spaceTemplate.clear":
      return {
        ...state,
        ...initialState,
      };

    default:
      return state;
  }
}
